import { FC, ReactElement } from "react";
import { Outlet } from "react-router-dom";

const Root: FC = (): ReactElement => {
  return <Outlet />;
};

export default Root;
